import { Button } from '@consta/uikit/Button'
import type { FC } from 'react'

import type { StepButtonsProps } from '../types'

export const StepSegyButtons: FC<StepButtonsProps> = ({
  onReturnDefaultValues,
  onSetupNextStepClick,
  onLoadingPrevStepClick,
  onConversionPrevStepClick,
  onLoadingResumePauseClick,
  onReadyPrevStepClick,
  uploadedFile,
  activeStep,
  onAddFilesToProject,
}) => {
  const loading = uploadedFile?.statuses?.loading
  switch (activeStep) {
    case 'setup': {
      return (
        <>
          <Button
            size="s"
            view="ghost"
            label="Сбросить настройки"
            onClick={onReturnDefaultValues}
          />
          <Button
            size="s"
            label="Далее"
            disabled={!uploadedFile?.setupContent || !uploadedFile.setupContent.isValid}
            onClick={onSetupNextStepClick}
          />
        </>
      )
    }
    case 'loading': {
      const isLoadingPaused = loading === 'paused'
      const isFileMine =
        uploadedFile?.origin === 'localMine' || uploadedFile?.origin === 'localAlien'
      const label = isLoadingPaused ? 'Продолжить загрузку' : 'Приостановить загрузку'
      return (
        <>
          <Button view="ghost" size="s" label="Назад" onClick={onLoadingPrevStepClick} />
          <Button
            size="s"
            label={label}
            disabled={!isFileMine}
            onClick={() => {
              onLoadingResumePauseClick(isLoadingPaused)
            }}
          />
        </>
      )
    }
    case 'conversion': {
      return <Button size="s" label="Назад" onClick={onConversionPrevStepClick} />
    }
    case 'ready': {
      return (
        <>
          <Button size="s" view="ghost" label="Назад" onClick={onReadyPrevStepClick} />
          <Button size="s" label="Добавить в проект" onClick={onAddFilesToProject} />
        </>
      )
    }
    default: {
      return null
    }
  }
}
